<template>
    <LayoutBase>
        <div class="full-height grid">
            <account-sidebar></account-sidebar>

            <div id="content-wrapper" class="app-position">
                <div class="container-fluid">
                    <div class="row no-gutters">
                        <div class="col-md-2"></div>
                        <div class="col-md-8">
                            <div class="grid">
                                <div class="col-4">
                                    <h3>Add navigation items</h3>
                                    <ul class="accordion">
                                        <li>
                                            <div class="accordion__title" v-on:click.stop.prevent="openAccordion('sections')">
                                                <h3>Groups</h3>
                                            </div>
                                            <div class="accordion__content" v-if="accordion === 'sections'">
                                                <div v-for="group in groups">
                                                    <label class="menu-item-title"><input type="checkbox" :value="group.id" v-model="chosenSections"> {{ group.name }}</label>
                                                </div>
                                                <div class="form__group">
                                                    <button class="btn btn-small" v-on:click.stop.prevent="addSections">Add to menu</button>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="accordion__title" v-on:click.stop.prevent="openAccordion('custom')">
                                                <h3>Custom Link</h3>
                                            </div>
                                            <div class="accordion__content" v-if="accordion === 'custom'">
                                                <div class="">
                                                    <div class="form__group">
                                                        <label class="form__label" for="name">URL</label>
                                                        <input type="url" id="name" name="name" class="form__control" v-model="custom_link.url" placeholder="https://">
                                                    </div>
                                                    <div class="form__group">
                                                        <label class="form__label" for="name">Link Text</label>
                                                        <input type="text" id="name" name="name" class="form__control" v-model="custom_link.link_text">
                                                    </div>
                                                    <div class="form__group">
                                                        <button class="btn btn-small" v-on:click.stop.prevent="addCustomLinks">Add to menu</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="accordion__title" v-on:click.stop.prevent="openAccordion('static')">
                                                <h3>Static Pages</h3>
                                            </div>
                                            <div class="accordion__content" v-if="accordion === 'static'">
                                                <div v-for="page in staticPages">
                                                    <label class="menu-item-title"><input type="checkbox" :value="page.id" v-model="chosenPages"> {{ page.name }}</label>
                                                </div>
                                                <div class="form__group">
                                                    <button class="btn btn-small" v-on:click.stop.prevent="addPage">Add to menu</button>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-8">
                                    <h3>Navigation</h3>
                                    
                                    <div class="">
                                        <div class="panel">
                                            <DraggableTree ref="nav" v-if="account.navigation" :data="account.navigation" draggable :space="5" @change="treeChange" @drop="treeChange" class="sortable-list">
                                                <div slot-scope="{data, store}">
                                                    <template v-if="!data.isDragPlaceHolder">
                                                        <div class="item" >
                                                            <div class="handle">
                                                                <div class="title">
                                                                    {{ data.text }} <i v-if="data.type === 'custom' && data.url && !data.url.includes('jetty.local')" class="icon ion-md-open"></i>
                                                                </div>
                                                                <div class="expand" v-on:click.stop.prevent="openMenuItem(data._id)">
                                                                    <i class="icon ion-md-arrow-dropdown"></i>
                                                                </div>
                                                            </div>

                                                            <div class="settings" :class="{ active: data._id === activeMenuItem }">

                                                                <div class="form__group">
                                                                    <label class="form__label" for="name">Link Text</label>
                                                                    <input type="text" class="form__control" v-model="data.text">
                                                                </div>

                                                                <a href="#" v-on:click.stop.prevent="store.deleteNode(data)">Remove</a>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </div>
                                            </DraggableTree>

                                            <div class="form__group">
                                                <button class="btn btn-primary" v-on:click.stop.prevent="saveSettings">Save Navigation</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-2"></div>
                    </div>
                </div>
            </div>
        </div>
    </LayoutBase>
</template>

<script>
    import LayoutBase from '../../layouts/LayoutBase';
    import {DraggableTree} from 'vue-draggable-nested-tree';

    export default {
        components: {
            LayoutBase,
            DraggableTree
        },
        data() {
            return {
                groups: [],
                staticPages: [
                    {
                        id: 'dashboard',
                        name: 'Home'
                    },
                    {
                        id: 'settings',
                        name: 'Settings'
                    },
                    {
                        id: 'groups',
                        name: 'Groups'
                    },
                    {
                        id: 'people',
                        name: 'People'
                    },
                ],
                account: {
                    navigation: []
                },
                custom_link: {
                    url : null,
                    link_text: null
                },
                accordion: null,
                activeMenuItem: null,
                chosenSections: [],
                chosenPages: []
            }
        },
        mounted() {
            this.getUsers();
            this.getGroups();
        },
        methods: {
            treeChange(node, nodeVm, store) {
                this.treeJson = nodeVm.pure(nodeVm.rootData, true);
            },
            saveSettings(){
                this.rebuildMenu();
            },
            rebuildMenu() {
                var nav = this.$refs.nav.getPureData();
                var url = '/api/account/navigation';

                axios.put(url, {navigation: nav}).then((response) => {
                    //this.group = response.data;
                    this.$store.commit('auth/setTeam', response.data);
                }, (response) => {
                    //console.log(response);
                    this.error = response;
                });
            },
            getUsers() {
                axios.get('/api/account/').then((response) => {
                    this.account = response.data; 
                }, (response) => {
                    this.error = response;
                });
            },
            getGroups() {
                axios.get('/api/groups').then((response) => {
                    this.groups = response.data;
                    //console.log(this.posts.slice(0, 1));
                }, (response) => {
                    this.error = response;
                });
            },
            openAccordion(type){
                this.accordion = type;
            },
            openMenuItem(type){
                if( this.activeMenuItem === type ){
                    this.activeMenuItem = null;
                }else{
                    this.activeMenuItem = type;
                }
            },
            addSections(){
                this.chosenSections.forEach(element => {

                    var found = this.groups.find(function(group) {
                        return group.id === element;
                    });

                    if( found ){
                        this.account.navigation.push({
                            type: 'section', url: found.slug, text: found.name
                        });
                    }
                });
            },
            addPage(){
                this.chosenPages.forEach(element => {

                    var found = this.staticPages.find(function(page) {
                        return page.id === element;
                    });

                    if( found ){
                        this.account.navigation.push({
                            type: 'page', 
                            url: found.id, 
                            text: found.name
                        });
                    }
                });
            },
            addCustomLinks(){
                this.account.navigation.push({
                    type: 'custom', url: this.custom_link.url, text: this.custom_link.link_text
                });

                this.custom_link.url = "";
                this.custom_link.link_text = "";
            }
        },
        // Guard to protect route from none admins
        beforeRouteEnter(to, from, next){
            if (!window.user_can.admin) next('/')
            else next()
        }
    }
</script>
<style lang="scss">
    .sortable-list{
        .item{
            border: 1px solid #ededed;
            border-radius: 2px;
            padding: 10px 16px;
            margin: 5px 0 0 0;
            background-color: white;

            .handle{
                display: flex;
                justify-content: space-between;
            }

            .title{
                cursor: move;
            }

            .expand{
                font-size: 18px;
            }

            .settings{
                display: none;

                &.active{
                    display: block;
                }
            }
        }
    }
</style>